var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94813 4.89827C4.74526 4.06 5.02698 3.82489 5.36666 3.71547C5.60174 3.65398 5.84828 3.65057 6.08498 3.70553C6.39659 3.79595 6.47902 3.86468 7.50076 4.88109C8.39844 5.77361 8.48812 5.87037 8.57417 6.04489C8.73876 6.35124 8.76448 6.71314 8.64482 7.0396C8.55424 7.28827 8.42561 7.45285 7.88121 7.99813L7.52613 8.35356C7.43292 8.44814 7.411 8.59174 7.47178 8.70984C8.26075 10.0534 9.37999 11.1739 10.7237 11.9652C10.8784 12.0479 11.0689 12.0212 11.1947 11.8992L11.5362 11.5637C11.7473 11.3477 11.9708 11.1442 12.2056 10.9543C12.5745 10.7282 13.034 10.708 13.4213 10.9009C13.6106 10.9913 13.6731 11.0474 14.5988 11.9698C15.5536 12.9202 15.5807 12.95 15.6858 13.1679C15.8836 13.5286 15.8815 13.9656 15.6804 14.3245C15.578 14.5271 15.5155 14.6003 14.9784 15.1483C14.6541 15.4793 14.3488 15.7813 14.2999 15.8256C13.8568 16.1918 13.2883 16.3715 12.7147 16.3266C11.6654 16.2311 10.6497 15.9073 9.73906 15.378C7.72197 14.311 6.00473 12.7566 4.74436 10.8566C4.46984 10.4589 4.22578 10.0411 4.01426 9.60689C3.44683 8.63596 3.15381 7.52966 3.1664 6.4057C3.20972 5.8177 3.49219 5.27302 3.94813 4.89827Z",
    stroke: "#355E3B",
    strokeWidth: 0.791667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.66a1aea08586120836baaa3d54cc1b6e.svg";
export { ForwardRef as ReactComponent };